import React from 'react';
import {FormProvider} from "react-hook-form";
import FormRenderProvider from "v4/components/form/FormRender/context/FormRenderContext";
import FormRest from "v4/components/form/FormRender/components/FormRest/FormRest";
import useFormRender from "v4/components/form/FormRender/hooks/useFormRender";
import ErrorBoundary from "components/Error/errorBoundary";

/**
 * @typedef {Object} FormV5
 * @property {"success:get-form-schema"} type
 * @property {Object} metadata
 * @property {Object} data
 */

/**
 * @typedef {Object} FormV4
 * @property {Object} metadata
 * @property {Object} results
 */

/**
 * @typedef {Object} FormErrorCore
 * @property {"client-error:unprocessable-entity"} type
 * @property {422} status
 * @property {{
 *     form: {
 *         messages: string[]
 *     },
 *     fields: {name: string, messages: string[]}[]
 * }} data
 */

/**
 * @typedef {Object} FormError
 * @property {string[]} messages
 */

/**
 * @param {FormV4 | FormV5} form
 * @param {import(react-hook-form).UseFormReturn} methods
 * @param {Object.<string, FormError>|FormErrorCore} formErrors
 * @param {string} formId
 * @param {string} formClassName
 * @param {function} onSubmit
 * @param {function: React.ReactNode} [formRender]
 * @param {function(field: Object, formRenderMethods:import(react-hook-form).UseFormReturn)} [fieldRender]
 * @param {boolean} hasToHideRest
 * @param {React.ReactNode} children
 */
export default function FormRender({
                                       form,
                                       formErrors,
                                       methods,
                                       formId,
                                       formClassName,
                                       formRender,
                                       fieldRender,
                                       onSubmit,
                                       hasToHideRest = false,
                                       children
                                   }) {
    const {
        formRenderMethods,
        handleSubmit
    } = useFormRender(methods, onSubmit, formErrors);

    if (!form || !(form.type === "success:get-form-schema" ? form.data : form.results)) return null;

    return (
        <ErrorBoundary>
            <FormRenderProvider form={form} fieldRender={fieldRender} formRenderMethods={formRenderMethods}>
                <FormProvider {...formRenderMethods}>
                    {formRender
                        ? formRender()
                        : (
                            <form id={formId} className={formClassName} onSubmit={handleSubmit}>
                                {children}

                                {!hasToHideRest && <FormRest/>}
                            </form>
                        )
                    }
                </FormProvider>
            </FormRenderProvider>
        </ErrorBoundary>
    )
}
